module.exports = "h3,\nh4,\nh5 {\n  margin: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/special/preacher-sermons/sermons.component.less
// module id = ./src/app/special/preacher-sermons/sermons.component.less
// module chunks = main